import { Skeleton } from '@/components/ui/skeleton'

interface SkeletonTableProps {
  columns?: number
  rows?: number
  hasCheckbox?: boolean
  hasActions?: boolean
}

export const SkeletonTable = ({
  columns = 5,
  rows = 10,
  hasCheckbox = false,
  hasActions = false,
}: SkeletonTableProps) => {
  return (
    <div className="w-full" role="status" aria-label="Loading table">
      <div className="rounded-md border">
        {/* Table Header */}
        <div className="border-b bg-muted/50">
          <div className="flex items-center h-12 px-4">
            {hasCheckbox && (
              <div className="w-12 flex items-center justify-center">
                <Skeleton className="h-4 w-4" />
              </div>
            )}
            {Array.from({ length: columns }).map((_, index) => (
              <div key={index} className="flex-1 px-2">
                <Skeleton className="h-4 w-24" />
              </div>
            ))}
            {hasActions && (
              <div className="w-16 flex items-center justify-center">
                <Skeleton className="h-4 w-12" />
              </div>
            )}
          </div>
        </div>

        {/* Table Body */}
        <div>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <div key={rowIndex} className="flex items-center h-12 px-4 border-b last:border-0">
              {hasCheckbox && (
                <div className="w-12 flex items-center justify-center">
                  <Skeleton className="h-4 w-4" />
                </div>
              )}
              {Array.from({ length: columns }).map((_, colIndex) => (
                <div key={colIndex} className="flex-1 px-2">
                  <Skeleton className="h-4 w-full" />
                </div>
              ))}
              {hasActions && (
                <div className="w-16 flex items-center justify-center">
                  <Skeleton className="h-8 w-8 rounded-full" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
